import React from "react";
import {styled, theme} from "@reside/ui";

export const PermissionsBulkStatusLegend = () => (
  <Root aria-label="Permission status legend">
    <LegendLabel>Legend:</LegendLabel>
    <LegendItem $tone="all">
      all N<span className="description"> = all users have it</span>
    </LegendItem>
    <Separator>·</Separator>
    <LegendItem $tone="partial">
      X of N<span className="description"> = partial</span>
    </LegendItem>
    <Separator>·</Separator>
    <LegendItem $tone="none">
      none<span className="description"> = no users have it</span>
    </LegendItem>
    <Separator>·</Separator>
    <LegendItem $tone="pending">
      (pending)<span className="description"> = unsaved change</span>
    </LegendItem>
  </Root>
);

const Root = styled.div`
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 16px;
`;

const LegendLabel = styled.span`
  color: ${theme.color.darkBlue100};
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
`;

const LegendItem = styled.span<{
  $tone: "all" | "partial" | "none" | "pending";
}>`
  color: ${({$tone}) =>
    $tone === "all"
      ? theme.color.green100
      : $tone === "partial"
      ? theme.color.orange100
      : theme.color.gray100};
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;

  .description {
    color: ${theme.color.gray150};
    font-weight: 400;
  }
`;

const Separator = styled.span`
  color: ${theme.color.gray100};
  font-size: 14px;
  line-height: 20px;
`;
